import React from 'react';
import style from './comboInfo.module.scss';
import { useState, useEffect } from 'react';
import apiConnect from '../../../config/apiConfig';
import {Spin} from 'antd';

const ComboInfo = ({combo}) => {

  const [stand, setStand] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    async function fetchStand () {
      const response = await apiConnect.get(`/stands/${combo.stand}`);
      setStand(response.data.data[0]);
      setLoading(false);
    }
    fetchStand();
  }, [combo.stand]);


  const {
    container,
    comboName,
    divider,
    containerInfo,
    title,
    row,
    fw300,
    listLayout,
    list,
    productItem,
    containerStyle, //eslint-disable-line
  } = style;
  
  return(
    <div className={container}>
      <h3 className={comboName}>Combo {combo.name}</h3>
      <hr className={divider}/>
      <div className={containerInfo}>
        <div className={`${row} ${containerStyle}`}>
          <h4 className={title}>Stand:</h4>
          {loading? <Spin/> : <h4 className={fw300}>{stand.name || 'Stand número ' + stand.standNumber}</h4>}
        </div>
        <div className={`${row} ${containerStyle}`}>
          <h4 className={title}>Cantidad de productos:</h4>
          <h4 className={fw300}>{combo.products?.length}</h4>
        </div>
        <div className={listLayout}>
          <h4 className={title}>Productos:</h4>
          <ul className={list}>
            {combo.products.map(product => {
              return(
                <li
                  key={product.product._id}
                  className={productItem}
                >
                  <ul className={list}>
                    <li>{product.product.description}</li>
                    <li>Código de barra: {product.product.barcode}</li>
                    <li>Pcio. Farm: ${product.product.pharmacyPrice}</li>
                    <li>Descuento por unidad: {product.discount * 100}%</li>
                    <li>Precio oferta por unidad: ${product.product.pharmacyPrice - (product.product.pharmacyPrice * product.discount)}</li>
                  </ul>
                </li>
              );
            })}
          </ul>
        </div>
        <div className={`${row} ${containerStyle}`}>
          <h4 className={title}>Hall:</h4>
          {loading? <Spin/> : <h4 className={fw300}>{stand.section}</h4>}
        </div>
        <div className={`${row} ${containerStyle}`}>
          <h4 className={title}>Plazo de pago:</h4>
          <h4 className={fw300}>{combo.paymentDeadline}</h4>
        </div>
        <div className={`${row} ${containerStyle}`}>
          <h4 className={title}>Tipo de combo:</h4>
          <h4 className={fw300}>{combo.closedCombo ? 'Combo cerrado' : 'Combo abierto' }</h4>
        </div>
      </div>
    </div>
  );  
};

export default ComboInfo;